module.exports = __webpack_public_path__ + "static/img/kumc-competition.437bc8b.jpg";


//////////////////
// WEBPACK FOOTER
// ./static/img/visual-marketing-detail/kumc-competition.jpg
// module id = mtL3
// module chunks = 0